import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Image } from 'theme-ui'

import Text from '~/components/IntlComponents/Text'
import { useTranslate } from '@chordcommerce/gatsby-theme-autonomy'

const GifterCard = ({ avatar, name, message, sx }) => {
  const translate = useTranslate()

  const wrapperStyles = {
    justifyContent: 'center',
    ...sx,
  }

  const cardStyles = {
    color: 'secondary',
    border: '1px solid',
    borderColor: 'tertiary',
    borderRadius: '8px',
    position: 'relative',
    flexFlow: 'column wrap',
    padding: '30px',
    width: ['auto', '500px'],
  }

  const firstRowStyles = {
    display: 'flex',
    flexFloe: 'row nowrap',
    justifyItems: 'center',
  }

  const avatarWrapperStyles = {
    display: 'flex',
    justifyContent: 'center',
    minWidth: '80px',
    height: '80px',
    lineHeight: '80px',
    borderRadius: '100%',
    backgroundColor: 'secondary',
    img: {
      margin: 'auto',
      lineHeight: '80px',
      width: avatar ? '80px' : '60px',
      height: avatar ? '80px' : '60px',
      borderRadius: '100%',
      objectFit: 'cover',
    },
  }

  const uerNameStyles = {
    display: 'flex',
    flexFlow: 'column',
    margin: 'auto 20px',
  }

  return (
    <Flex sx={wrapperStyles}>
      <Flex sx={cardStyles} data-testid="gifter-card">
        <Flex sx={firstRowStyles}>
          <Box sx={avatarWrapperStyles}>
            <Image src={avatar || '/images/logo.png'} />
          </Box>
          <Box sx={uerNameStyles}>
            <Text sx={{ fontSize: '14px', fontWeight: '700' }}>
              {translate('gifting_flow.card.gift_from')}
            </Text>
            <Text sx={{ fontSize: '24px', fontWeight: '700' }}>{name}</Text>
          </Box>
        </Flex>
        <Flex m={'auto'}>
          <Text
            mt={30}
            sx={{ fontSize: '20px', fontWeight: '700', textAlign: 'center' }}
          >
            {message ?? translate('gifting_flow.card.default_message')}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
}

GifterCard.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string.isRequired,
  message: PropTypes.string,
  sx: PropTypes.object,
}

export default GifterCard
